module.exports = __webpack_public_path__ + "img/pub1.6221f27d.png";